module.exports = __webpack_public_path__ + "static/media/datsuraku-icon.dee401fe.svg";